import { render, staticRenderFns } from "./RedeemPoints.vue?vue&type=template&id=be9f0156"
import script from "./RedeemPoints.vue?vue&type=script&lang=js"
export * from "./RedeemPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports